import { render, staticRenderFns } from "./k-tag-custom.vue?vue&type=template&id=76770e50&"
import script from "./k-tag-custom.vue?vue&type=script&lang=js&"
export * from "./k-tag-custom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports